var View = require('views/base/view');

var ModuleLinkView = View.extend({
  noWrap: true,
  autoRender: true,
  initialize: function(options) {
    this.template = options.moduleTemplate ? require(options.moduleTemplate) : require('./templates/module-link');
    View.prototype.initialize.apply(this, arguments);
  }
});

module.exports = ModuleLinkView;
